import { deleteDoc, where } from "firebase/firestore"
import { getRevendaIdByPark, getUsuario } from '../../config/auth'
import { Collection, WhereField } from '../../shared/constants'
import { chunkItemsByQuantity, isNullOrEmpty } from '../../shared/utils'
import { addDoc, getAllDocsByParkId, getAllDocsByQueries, getDocById, updateDoc } from './collectionBaseWorker'

export const addRelationship = async ({ data, clientId, estacionamentoId, tipo, valor, nome, status, tolerancia, manterDesconto }) => {
    if (!isNullOrEmpty(data)) {
        await addDoc({ collection: Collection.PARTNERSHIP, data: data })
    } else {
        const data = {
            tipo: tipo,
            estacionamentoId: estacionamentoId,
            clienteId: clientId,
            valor: valor,
            porcentagem: valor,
            nome: nome,
            status: status,
            tolerancia: tolerancia,
            manterDesconto: manterDesconto,
            createdAt: new Date(),
            createdBy: getUsuario().email,
            revendaId: getRevendaIdByPark(),
            isDeleted: false,
        }
        const doc = await addDoc({ collection: Collection.PARTNERSHIP, data: data })
        return doc.id
    }
}

export const getAllConveniosByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByParkId({ collection: Collection.PARTNERSHIP, estacionamentoId: estacionamentoId })
}

export const getAllConveniosOnlineByClientId = async ({ clienteId }) => {
    return await getAllDocsByQueries({
        collection: Collection.PARTNERSHIP,
        queries: [
            where(WhereField.CLIENTEID, "==", clienteId),
            where(WhereField.STATUS, "==", "Ativo"),
            where(WhereField.ONLINE, "==", true)
        ]
    })
}

export const getAllConveniosOnlineByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.PARTNERSHIP,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.STATUS, "==", "Ativo"),
            where(WhereField.ONLINE, "==", true)
        ]
    })
}

export const getAllPartnersByIds = async ({ ids }) => {
    var results = []
    const items = chunkItemsByQuantity({ items: ids })
    for (const item of items) {
        const result = await getAllDocsByQueries({
            collection: Collection.PARTNERSHIP,
            queries: [
                where(WhereField.ID, "in", ids),
            ]
        })
        results.push(...result)
    }
    return results
}

export const getAllRelationshipsByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.PARTNERSHIP,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.STATUS, "==", "Ativo")
        ]
    })
}

export const getRelationshipById = async ({ id }) => {
    return await getDocById({ collection: Collection.PARTNERSHIP, id: id })
}

export const getAllRelationshipsByClientId = async ({ clienteId }) => {
    return await getAllDocsByQueries({
        collection: Collection.PARTNERSHIP,
        queries: [
            where(WhereField.CLIENTEID, "==", clienteId),
            where(WhereField.STATUS, "==", "Ativo")
        ]
    })
}

export const updateRelationshipById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.PARTNERSHIP, id: id, data: data })
}

export const deleteRelationshipById = async ({ id }) => {
    await deleteDoc({ collection: Collection.PARTNERSHIP, id: id })
}